import { Box, Container, Typography } from "@mui/material";
import { useState } from "react";

import ActionsModal from "../../components/ActionsModal";

import ReferencesTable from "./References.table";

const References = () => {
  const [actionNumber, setActionNumber] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const handleActionClick = (number: number) => {
    setActionNumber(number);
    setShowModal(true);
  };

  return (
    <Container maxWidth="xl">
      <Box m={2}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          Training Center
        </Typography>
        <Typography variant="h5" sx={{ mb: 3 }}>
          References
        </Typography>
        <ActionsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          actionNumber={actionNumber}
        />
        <ReferencesTable onActionClick={handleActionClick} />
      </Box>
    </Container>
  );
};

export default References;
